module.exports = __webpack_public_path__ + "img/icon-payment-app.311bc0f4.png";